import { cva } from 'class-variance-authority';

export const containerVariants = cva('', {
  variants: {
    variant: {
      list: 'w-[27.5rem] min-h-[3.25rem]',
      default: 'gap-2xl',
      step: 'w-[27.5rem] min-h-[3.25rem]',
      status: 'w-[20rem] gap-2xl',
    },
    size: {
      sm: '',
      md: '',
    },
  },
  compoundVariants: [
    {
      variant: 'default',
      size: 'sm',
      className: 'w-[14.25rem]',
    },
    {
      variant: 'default',
      size: 'md',
      className: 'w-[23.75rem]',
    },
  ],
});

export const titleVariants = cva('w-full', {
  variants: {
    variant: {
      list: 'text-md',
      default: '',
      step: 'text-md',
      status: 'text-sm',
    },
    size: {
      sm: 'text-sm',
      md: 'text-md',
    },
  },
});

export const descriptionVariants = cva('w-full', {
  variants: {
    size: {
      sm: 'text-xs',
      md: 'text-sm',
    },
  },
});
